var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "apply-domain-template-modal",
        title: _vm.$t("label.domain_add"),
        scrollable: "",
        "hide-footer": "",
      },
    },
    [
      _c("div", [
        _vm._v("\n    En cliquant sur "),
        _c("b", [_vm._v("Ajouter")]),
        _vm._v(
          ", vous ajoutez les domaines d'un template à l'établissement. Les domaines en double ne seront pas dupliqués."
        ),
        _c("br"),
        _vm._v("\n    En cliquant sur "),
        _c("b", [_vm._v("Remplacer")]),
        _vm._v(
          ", les domaines actuels de l'établissement seront désactivés et les domaines du template seront appliqués avec l'association des patgames à l'établissement. Il faudra ré-associer les activités externes aux domaines de l'établissement.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("b-table", {
        attrs: { fields: _vm.fields, items: _vm.templates },
        scopedSlots: _vm._u([
          {
            key: "cell(action)",
            fn: function (row) {
              return [
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.showDomains(row.item)
                      },
                    },
                  },
                  [_vm._v("Voir")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: {
                      size: "sm",
                      variant: "primary",
                      disabled: _vm.loading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.add(row.item.id, false)
                      },
                    },
                  },
                  [_vm._v("Ajouter")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: {
                      size: "sm",
                      variant: "warning",
                      disabled: _vm.loading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.add(row.item.id, true)
                      },
                    },
                  },
                  [_vm._v("Remplacer")]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal-show-domains-template-info", {
        ref: "modalShowDomainsTemplateInfo",
        attrs: { establishment: _vm.establishment },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }